import React from "react";
import { MdVerified } from "react-icons/md";
import { GoVerified } from "react-icons/go";

const VerifiedIcon = ({ is_verified, is_celebrity, size = 20 }) => {
  if (!is_verified && !is_celebrity) return null;

  if (is_celebrity) {
    return <MdVerified size={size} color="#1DA1F2" />;
  }

  if (is_verified) {
    return <GoVerified size={size} color="#9b59b6" />;
  }

  return null;
};

export default VerifiedIcon;
